<template>
  <div id="header" class="header soulody header-down">
    <main>
      <div class="section">
        <aside>
          <AppLink
            :to="$localePath({ name: 'index', hash: 'top' })"
            :target="currentPath === 'index' ? '_self' : '_blank'"
            @click="
              gtmPush({
                event: 'button_click',
                link_text: 'Logo',
                link_location: 'header'
              })
            "
          >
            <img :src="logoImg" alt="logo" />
          </AppLink>
        </aside>
        <div class="spacer"></div>
        <nav class="desktop">
          <AppLink
            :to="$localePath({ name: 'index', hash: 'data' })"
            :target="currentPath === 'index' ? '_self' : '_blank'"
            @click="
              gtmPush({
                event: 'button_click',
                link_text: $t('homepage.header.nav.link[0]'),
                link_location: 'header-desktop'
              })
            "
          >
            {{ $t('homepage.header.nav.link[0]') }}
          </AppLink>
          <AppLink
            :to="$localePath({ name: 'index', hash: 'vision' })"
            :target="currentPath === 'index' ? '_self' : '_blank'"
            @click="
              gtmPush({
                event: 'button_click',
                link_text: $t('homepage.header.nav.link[1]'),
                link_location: 'header-desktop'
              })
            "
          >
            {{ $t('homepage.header.nav.link[1]') }}
          </AppLink>
          <AppLink
            v-if="$domainRegion === 'cz'"
            :to="$localePath({ name: 'index', hash: 'references' })"
            :target="currentPath === 'index' ? '_self' : '_blank'"
            @click="
              gtmPush({
                event: 'button_click',
                link_text: $t('homepage.header.nav.link[2]'),
                link_location: 'header-desktop'
              })
            "
          >
            {{ $t('homepage.header.nav.link[2]') }}
          </AppLink>
          <AppLink
            v-if="$i18n.locale === 'cs'"
            :to="$localePath('servicePage')"
            :target="currentPath === 'index' ? '_self' : '_blank'"
            @click="
              gtmPush({
                event: 'button_click',
                link_text: $t('homepage.header.nav.link[3]'),
                link_location: 'header-desktop'
              })
            "
          >
            {{ $t('homepage.header.nav.link[3]') }}
          </AppLink>
          <div v-if="$domainRegion === 'cz' && $i18n.locale === 'cs'" class="holder__buttons__icon">
            <HamburgerIcon
              ref="hamburgerMenuDesktop"
              :lines="3"
              class="hamburger-menu"
              @click.native="toggleMenu"
            />
            <ul :class="['holder__submenu', { open: isMenuOpen }]">
              <li v-for="(link, index) in submenuLinks" :key="`submenu_${index}`">
                <component
                  :is="link.to ? 'router-link' : 'a'"
                  :href="link.href"
                  :to="link.to"
                  @click.native="closeMenu(link.text)"
                >
                  {{ link.text }}
                </component>
              </li>
            </ul>
          </div>
          <div v-if="$domainRegion === 'cz' && currentPath === 'index'" class="lang-group">
            <span class="nav-divider"></span>
            <a
              class="lang-link"
              :href="$switchLocalePath(otherLocale)"
              @click="gtmSelectLanguage(otherLocale)"
            >
              {{ otherLocaleLabel }}
            </a>
          </div>
        </nav>
        <a
          v-if="$domainRegion === 'cz' && currentPath === 'index'"
          class="lang-link lang-link--bar"
          :href="$switchLocalePath(otherLocale)"
          @click="gtmSelectLanguage(otherLocale)"
        >
          {{ otherLocaleLabel }}
        </a>
        <nav class="mobile">
          <HamburgerIcon ref="hamburgerMenu" class="hamburger-menu" />
        </nav>
      </div>

      <ul ref="mobileMenu" class="mobile-menu heading-3-4">
        <li>
          <AppLink
            :to="$localePath({ name: 'index', hash: 'data' })"
            :target="currentPath === 'index' ? '_self' : '_blank'"
            @click="
              gtmPush({
                event: 'button_click',
                link_text: $t('homepage.header.nav.link[0]'),
                link_location: 'header-mobile'
              })
            "
          >
            {{ $t('homepage.header.nav.link[0]') }}
          </AppLink>
        </li>
        <li>
          <AppLink
            :to="$localePath({ name: 'index', hash: 'vision' })"
            :target="currentPath === 'index' ? '_self' : '_blank'"
            @click="
              gtmPush({
                event: 'button_click',
                link_text: $t('homepage.header.nav.link[1]'),
                link_location: 'header-mobile'
              })
            "
          >
            {{ $t('homepage.header.nav.link[1]') }}
          </AppLink>
        </li>
        <li v-if="$domainRegion !== 'sk'">
          <AppLink
            :to="$localePath({ name: 'index', hash: 'references' })"
            :target="currentPath === 'index' ? '_self' : '_blank'"
            @click="
              gtmPush({
                event: 'button_click',
                link_text: $t('homepage.header.nav.link[2]'),
                link_location: 'header-mobile'
              })
            "
          >
            {{ $t('homepage.header.nav.link[2]') }}
          </AppLink>
        </li>
        <li>
          <AppLink
            v-if="$i18n.locale === 'cs'"
            :to="$localePath('servicePage')"
            :target="currentPath === 'index' ? '_self' : '_blank'"
            @click="
              gtmPush({
                event: 'button_click',
                link_text: $t('homepage.header.nav.link[3]'),
                link_location: 'header-mobile'
              })
            "
          >
            {{ $t('homepage.header.nav.link[3]') }}
          </AppLink>
        </li>
        <li v-if="$domainRegion === 'cz' && $i18n.locale === 'cs'">
          <AppLink
            :to="$localePath('careerPage')"
            :target="currentPath === 'index' ? '_self' : '_blank'"
            @click="
              gtmPush({
                event: 'button_click',
                link_text: $t('homepage.header.nav.link[4]'),
                link_location: 'header-mobile'
              })
            "
          >
            {{ $t('homepage.header.nav.link[4]') }}
          </AppLink>
        </li>
        <li v-if="$i18n.locale === 'cs'">
          <AppLink
            :to="$localePath('contactPage')"
            :target="currentPath === 'index' ? '_self' : '_blank'"
            @click="
              gtmPush({
                event: 'button_click',
                link_text: $t('homepage.header.nav.link[5]'),
                link_location: 'header-mobile'
              })
            "
          >
            {{ $t('homepage.header.nav.link[5]') }}
          </AppLink>
        </li>
        <li>
          <AppLink
            :to="$localePath('login')"
            class="login-button"
            @click="
              gtmPush({
                event: 'button_click',
                link_text: $t('homepage.header.nav.login'),
                link_location: 'header-mobile'
              })
            "
          >
            <h4 class="soulody__header__content__kz__text">
              {{ $t('homepage.header.nav.login') }}
            </h4>
            <div class="soulody__header__content__kz__button">
              <img :src="$asset('homepage/img/icons/external.svg')" alt="" />
            </div>
          </AppLink>
        </li>
      </ul>

      <AppLink
        :to="$localePath('login')"
        class="login-button"
        @click="
          gtmPush({
            event: 'button_click',
            link_text: $t('homepage.header.nav.login'),
            link_location: 'header-desktop'
          })
        "
      >
        <div class="soulody__header__content__kz__text">{{ $t('homepage.header.nav.login') }}</div>
        <div class="soulody__header__content__kz__button">
          <img :src="$asset('homepage/img/icons/external.svg')" alt="" />
        </div>
      </AppLink>
    </main>
  </div>
</template>

<script>
export default {
  name: 'HomepageHeader',
  data() {
    return {
      submenuItems: [
        ['servicePage.header.submenu.career', 'kariera'],
        ['servicePage.header.submenu.contact', { routeName: 'contactPage' }]
      ],
      isMenuOpen: false
    };
  },
  computed: {
    logoImg() {
      return this.$asset(
        `img/logo${this.$domainRegion !== 'cz' ? `-${this.$domainRegion}` : ''}.svg`
      );
    },
    otherLocale() {
      return this.$i18n.locale === 'en' ? 'cs' : 'en';
    },
    otherLocaleLabel() {
      return this.otherLocale === 'en' ? 'EN' : 'CZ';
    },
    submenuLinks() {
      return this.submenuItems.map(linkDef => {
        const linkConfig = linkDef[1];

        if (typeof linkConfig === 'object' && linkConfig.routeName) {
          return {
            text: this.$t(linkDef[0]),
            to: this.$localePath(linkConfig.routeName)
          };
        }

        return {
          text: this.$t(linkDef[0]),
          href: `${import.meta.env.VITE_OLD_WEB_URL}/${linkConfig}`
        };
      });
    }
  },
  mounted() {
    if (window.matchMedia('(max-width: 930px)').matches) {
      let didScroll = false;
      let lastScrollTop = 0;
      const delta = 5;
      const navbarHeight = this.$el.offsetHeight;

      window.addEventListener('scroll', () => {
        didScroll = true;
      });

      setInterval(() => {
        if (didScroll) {
          const hamburger = this.$refs.hamburgerMenu;
          const menu = this.$refs.mobileMenu;

          const st = window.pageYOffset || document.documentElement.scrollTop;
          if (Math.abs(lastScrollTop - st) > delta) {
            if (st > lastScrollTop && st > navbarHeight) {
              if (menu?.classList?.contains('visible')) {
                hamburger.toHamburger();
                menu.classList.remove('visible');
              }

              this.$el.style.display = 'none';
            } else if (st + window.innerHeight < document.body.scrollHeight) {
              this.$el.style.display = 'block';
            }
            lastScrollTop = st;
          }
          didScroll = false;
        }
      }, 250);
    }

    this.$nextTick(() => {
      const hamburger = this.$refs.hamburgerMenu;
      const menu = this.$refs.mobileMenu;
      hamburger.$el.style.cursor = 'pointer';

      hamburger.$el.addEventListener('click', () => {
        if (menu.classList.contains('visible')) {
          hamburger.toHamburger();
          menu.classList.remove('visible');
        } else {
          hamburger.toCross();
          menu.classList.add('visible');
        }
      });

      const links = menu.querySelectorAll('a');
      links.forEach((el, idx) => {
        if (idx < links.length - 1) {
          el.addEventListener('click', () => {
            hamburger.toHamburger();
            menu.classList.remove('visible');
          });
        }
      });
    });

    document.addEventListener('click', this.handleOutsideClick);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleOutsideClick);
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
      const hamburger = this.$refs.hamburgerMenuDesktop;
      if (this.isMenuOpen) {
        hamburger.toCross();
      } else {
        hamburger.toHamburger();
      }
    },
    closeMenu(linkText) {
      if (!this.isMenuOpen) {
        return;
      }

      this.isMenuOpen = false;
      const hamburger = this.$refs.hamburgerMenuDesktop;
      hamburger.toHamburger();

      this.gtmPush({
        event: 'button_click',
        link_text: linkText,
        link_location: 'header'
      });
    },
    handleOutsideClick(event) {
      if (!this.isMenuOpen) {
        return;
      }
      const holder = this.$el.querySelector('.holder__buttons__icon');
      if (holder && !holder.contains(event.target)) {
        this.isMenuOpen = false;
        this.$refs.hamburgerMenuDesktop?.toHamburger();
      }
    }
  }
};
</script>

<style scoped>
.header.soulody {
  --brand: #3ca091;
  --brand-lighten: #a0e6dc;
  --primary: var(--brand);
  --background-secondary: var(--brand-lighten);
  --grey-darken-1: #bebebd;

  width: 100%;
  position: fixed;
  top: calc(env(safe-area-inset-top) + 16px);
  z-index: 12;
  height: 56px;
  max-height: 56px;
  pointer-events: none;

  .heading-3-4 {
    font-size: 24px;
    line-height: 28.8px;
  }

  @media screen and (max-width: 930px) {
    top: calc(env(safe-area-inset-top) + 4px);
  }

  > main {
    width: 923px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    pointer-events: none;

    @media screen and (max-width: 930px) {
      width: calc(100% - 24px);
      margin: 0 12px;
    }

    > .section {
      width: 100%;
      max-width: 735px;
      padding: 8px;
      border-radius: 16px;
      background-color: rgba(255, 255, 255, 0.8);
      backdrop-filter: blur(12px);
      display: flex;
      align-items: center;
      position: relative;
      z-index: 10;
      pointer-events: all;

      @media screen and (max-width: 930px) {
        max-width: 100%;
      }

      > aside {
        padding: 12px;
        background-color: white;
        border-radius: 8px;
        height: 40px;
        display: flex;

        @media screen and (max-width: 930px) {
          background-color: transparent;
        }

        img {
          height: 15px;
        }
      }

      > div.spacer {
        content: '';
        height: 16px;
        border: 1px solid var(--grey-darken-1);
        margin-left: 16px;
        border-radius: 8px;
        box-sizing: content-box;
        flex-grow: 0;
        flex-shrink: 1;

        @media screen and (max-width: 930px) {
          border: none;
          flex-grow: 1;
          flex-shrink: 0;
        }
      }

      > nav {
        > a {
          color: black !important;
          text-decoration: none !important;
        }
      }

      > nav.desktop {
        display: flex;
        justify-content: space-evenly;
        width: 100%;
        align-items: center;

        @media screen and (max-width: 930px) {
          display: none;
        }
      }

      > .switcher {
        @media screen and (max-width: 930px) {
          /*justify-content: flex-end;*/
          /*margin-right: 16px;*/
          display: none;
        }
      }

      > .lang-link--bar {
        display: none;
        align-items: center;
        line-height: 1;
        /* optical centering: uppercase glyphs sit above the line-box center, nudge to match the hamburger */
        transform: translateY(1px);
        margin-right: 12px;

        @media screen and (max-width: 930px) {
          display: inline-flex;
        }
      }

      > nav.mobile {
        display: none;
        width: 40px;
        height: 40px;
        background-color: white;
        border-radius: 8px;
        padding: 8px;
        position: relative;
        font-size: 14px;
        line-height: 21px;

        @media screen and (max-width: 930px) {
          display: block;
        }

        iframe {
          border: none;
        }
      }
    }

    > a.login-button,
    > ul.mobile-menu > li > a.login-button {
      padding: 8px;
      border-radius: 16px;
      background-color: rgba(255, 255, 255, 0.8);
      backdrop-filter: blur(12px);
      display: flex;
      align-items: center;
      color: black !important;
      text-decoration: none !important;
      pointer-events: all;

      .soulody__header__content__kz__text {
        margin-left: 8px;

        @media screen and (max-width: 930px) {
          font-size: 18px;
        }
      }

      .soulody__header__content__kz__button {
        height: 40px;
        cursor: pointer;
        margin-left: 16px;
        padding: 8px;
        border-radius: 8px;
        background-color: var(--primary);
      }
    }

    > a.login-button {
      width: 180px;
      justify-content: space-between;

      > .soulody__header__content__kz__text {
        text-align: center;
        width: 100%;
      }
    }

    > ul.mobile-menu {
      visibility: hidden;
      opacity: 0;
      position: absolute;
      list-style-type: none;
      background-color: #f1f0f0;
      padding: 16px;
      overflow: hidden;
      border-radius: 16px;
      transition: all 0.4s ease-in-out;
      display: flex;
      flex-direction: column;
      width: 100vw;
      height: 0;
      top: -8px;
      left: 0;
      z-index: 1;
      align-items: flex-end;
      justify-content: center;
      pointer-events: all;

      &.visible {
        @media screen and (max-width: 930px) {
          visibility: visible;
          opacity: 1;
          height: 100vh;
        }
      }

      > li {
        min-width: max-content;

        &:not(:first-child) {
          margin-top: 21px;
        }

        &:last-child {
          margin-top: 32px;
        }

        > a {
          color: black !important;
          text-decoration: none;
          margin-right: 8px;
        }
      }
    }

    > a.login-button {
      @media screen and (max-width: 930px) {
        display: none;
      }
    }
  }
}
.header-submenu-link {
  &:hover {
    background-color: $grey;
    display: block;
  }
}
.holder__buttons__icon {
  cursor: pointer;
  border-radius: 50%;
  display: flex !important;
  padding: 0 1rem;

  .holder__submenu {
    opacity: 0;
    top: 40px;
    z-index: -100;
    pointer-events: none;
    position: absolute;
    background: #fff;
    border-radius: 16px;
    padding: 8px;
    width: max-content;
    min-width: 168px;
    right: 0;
    display: flex;
    flex-direction: column;
    gap: 2px;
    box-shadow: 0 12px 32px rgba(20, 20, 20, 0.12);
    transition:
      opacity 0.25s linear,
      top 0.25s linear,
      z-index 0.25s linear;

    &.open {
      top: 54px;
      z-index: 10002;
      opacity: 1;
      pointer-events: all;
    }
  }

  ul {
    list-style: none;

    li {
      padding: 0;
      position: relative;

      a {
        color: #141414 !important;
        font-size: 16px;
        font-style: normal;
        line-height: 140%;
        padding: 10px 16px !important;
        border-radius: 0.75rem;
        width: 100%;
        display: block;
        transition: background-color 0.15s ease;

        &:hover {
          background-color: $grey !important;
        }
      }
    }
  }
}
.lang-group {
  display: flex;
  align-items: center;
  gap: 16px;
}
.nav-divider {
  height: 16px;
  border: 1px solid var(--grey-darken-1);
  border-radius: 8px;
  box-sizing: content-box;
  flex-shrink: 0;
}
.lang-link {
  font-family: PangramSans, sans-serif;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.32px;
  color: #000 !important;
  text-decoration: none;
  cursor: pointer;
  white-space: nowrap;
  transition: opacity 0.15s ease;
}
.lang-link:hover {
  opacity: 0.7;
}
.lang-link--mobile {
  font-size: 18px;
}
</style>
